export const resetAllFocusStyle = (container: HTMLElement, reset: (element: HTMLElement) => void) => {
  const listElements = container.querySelectorAll<HTMLElement>('[data-index]')
  listElements.forEach((element) => {
    reset(element)
  })
}
